import { getISODateTime } from "../../utils/momentUtils";

// ------------- Form Data for Save ------------- //

export const createDiscountProgramFormData = (data) => {
  return {
    programName: data.programName,
    startDate: getISODateTime(data.startDate),
    endDate: getISODateTime(data.endDate),
    discountProgramDetails: data.discountProgramDetails,
  };
};

export const createDiscountProgramItemFormData = (
  data,
  isEdit = false,
  entityId = null
) => {
  const categoryId = data?.category?.id;
  const isManufacturer = categoryId === "manufacturer";
  const isManufacturerGroup = categoryId === "manufacturer_group";
  const typeId = isManufacturer
    ? data?.option?.id || data?.option?.manufacturerId
    : isManufacturerGroup
    ? data?.option?.id || data?.option?.manufacturerGroupId
    : data?.option?.value?.categoryId || data?.option?.categoryId;
  const typeName = isManufacturer
    ? data?.option?.label || data?.option?.manufacturerName
    : isManufacturerGroup
    ? data?.option?.label || data?.option?.name
    : data?.option?.value?.categoryName || data?.option?.categoryName;
  const resolvedEntityId =
    entityId ?? data?.entityId ?? data?.entity?.entityId ?? null;
  return {
    min: data.min,
    max: data.max,
    discPerDefault: data.discount || data.discPerDefault,
    typeId,
    typeName,
    type: data.category?.id,
    discountProgramDetailsId: data.discountProgramDetailsId,
    entityId: resolvedEntityId,
    ...(isEdit && { option: data.option }),
    ...(isEdit && { category: data.category }),
  };
};
